import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PROTECTED_VIEWS_UNLOCK } from '../../router/routeNames';
import FirestoreProtectedViews from '../../api/firebase/firebase.protectedViews';
import { useSelector } from 'react-redux';

const withLockedView = (Component) => () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function HandleViewLocked() {
      const userId = user?.data?.uid;
      const pageStatus = await FirestoreProtectedViews.GetPageProtectionStatus(
        userId,
        location.pathname
      );
      if (pageStatus.isLocked) {
        navigate(`${PROTECTED_VIEWS_UNLOCK}${location.pathname}`, {
          replace: true,
          route: location.pathname,
        });
      }
    }
    HandleViewLocked();
  }, []);
  return (
    <>
      <Component />
    </>
  );
};

export default withLockedView;
